export class PageView {
    _customerAccountId;
    _visitorId;
    _hasAdBlocker;
    _screenDepth;
    _screenSize;
    _doNotTrack;
    _fonts;
    _hasFakeBrowserInfos;
    _hasFakeLanguageInfos;
    _hasFakeOsInfos;
    _hasFakeResolutionInfos;
    _userLanguage;
    _deviceCategory;
    _pixelRatio;
    _plugins;
    _documentReferer;
    _viewportSize;
    _touchSupport;
    _currentUrl;
    _userAgent;
    _customerUserId;
    _timezoneOffset;
    _eventCategory;
    get customerAccountId() {
        return this._customerAccountId;
    }
    get visitorId() {
        return this._visitorId;
    }
    get hasAdBlocker() {
        return this._hasAdBlocker;
    }
    get screenDepth() {
        return this._screenDepth;
    }
    get screenSize() {
        return this._screenSize;
    }
    get doNotTrack() {
        return this._doNotTrack;
    }
    get fonts() {
        return this._fonts;
    }
    get hasFakeBrowserInfos() {
        return this._hasFakeBrowserInfos;
    }
    get hasFakeLanguageInfos() {
        return this._hasFakeLanguageInfos;
    }
    get hasFakeOsInfos() {
        return this._hasFakeOsInfos;
    }
    get hasFakeResolutionInfos() {
        return this._hasFakeResolutionInfos;
    }
    get userLanguage() {
        return this._userLanguage;
    }
    get deviceCategory() {
        return this._deviceCategory;
    }
    get pixelRatio() {
        return this._pixelRatio;
    }
    get plugins() {
        return this._plugins;
    }
    get documentReferer() {
        return this._documentReferer;
    }
    get viewportSize() {
        return this._viewportSize;
    }
    get touchSupport() {
        return this._touchSupport;
    }
    get currentUrl() {
        return this._currentUrl;
    }
    get userAgent() {
        return this._userAgent;
    }
    get customerUserId() {
        return this._customerUserId;
    }
    get timezoneOffset() {
        return this._timezoneOffset;
    }
    get eventCategory() {
        return this._eventCategory;
    }
    constructor({ customerAccountId, visitorId, hasAdBlocker, screenDepth, screenSize, doNotTrack, fonts, hasFakeBrowserInfos, hasFakeLanguageInfos, hasFakeOsInfos, hasFakeResolutionInfos, userLanguage, deviceCategory, pixelRatio, plugins, documentReferer, viewportSize, touchSupport, currentUrl, userAgent, customerUserId, timezoneOffset, eventCategory }) {
        this._customerAccountId = customerAccountId;
        this._visitorId = visitorId;
        this._hasAdBlocker = hasAdBlocker;
        this._screenDepth = screenDepth;
        this._screenSize = screenSize;
        this._doNotTrack = doNotTrack;
        this._fonts = fonts;
        this._hasFakeBrowserInfos = hasFakeBrowserInfos;
        this._hasFakeLanguageInfos = hasFakeLanguageInfos;
        this._hasFakeOsInfos = hasFakeOsInfos;
        this._hasFakeResolutionInfos = hasFakeResolutionInfos;
        this._userLanguage = userLanguage;
        this._deviceCategory = deviceCategory;
        this._pixelRatio = pixelRatio;
        this._plugins = plugins;
        this._documentReferer = documentReferer;
        this._viewportSize = viewportSize;
        this._touchSupport = touchSupport;
        this._currentUrl = currentUrl;
        this._userAgent = userAgent;
        this._customerUserId = customerUserId;
        this._timezoneOffset = timezoneOffset;
        this._eventCategory = eventCategory;
    }
    toApiKeys() {
        const apiKeys = {
            cid: this._customerAccountId,
            vid: this._visitorId,
            adb: this._hasAdBlocker,
            sd: this._screenDepth,
            sr: this._screenSize,
            dnt: this._doNotTrack,
            fnt: this._fonts,
            hlb: this._hasFakeBrowserInfos,
            hll: this._hasFakeLanguageInfos,
            hlo: this._hasFakeOsInfos,
            hlr: this._hasFakeResolutionInfos,
            ul: this._userLanguage,
            dc: this._deviceCategory,
            pxr: this._pixelRatio,
            dr: this._documentReferer,
            vp: this._viewportSize,
            tof: this._timezoneOffset,
            tsp: this._touchSupport,
            dl: this._currentUrl,
            ua: this._userAgent,
            ec: this._eventCategory,
            t: 'PAGEVIEW'
        };
        if (this._plugins) {
            apiKeys.plu = this._plugins;
        }
        if (this._customerUserId) {
            apiKeys.cuid = this._customerUserId;
        }
        return apiKeys;
    }
}
